export default __webpack_public_path__ + "static/media/kitchen5-afterD-1920w.d27f3bb9.avif";